import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-change-log-modal',
    templateUrl: './change-log-modal.component.html',
    styleUrls: ['./change-log-modal.component.scss'],
    standalone: false
})
export class ChangeLogModalComponent {

    constructor(private readonly modalCtrl: ModalController) {
    }

    public closeModal() {
        // 1. Store the version code in local storage

        // 2. Close the modal
        return this.modalCtrl.dismiss(null, 'cancel');
    }
}
